import React from 'react';
// import moment from 'moment';
import Moment from 'react-moment';
import miscUtils from 'utils/miscUtils';
import { IEventsBlockEventPreviewProps } from './IEventsBlockEventPreviewProps';
import styled from 'styled-components';
import { ReactComponent as ImageIcon } from 'containers/Library/Community/Courses/icons/image.svg';
import { isValidHexColor } from 'components/PageBuilder/PageBuilderSideBar/BlockSettings/domain';
import { ShadowPosition } from 'containers/PageBuilder/SinglePageContainer/domain';
import eventsUtils from 'containers/events/eventsUtils';

const EventWrapper: any = styled.div<{design: any}>`
    flex: 0 1 calc((100% - 40px) / 3);
    border-radius: ${(props: any) => 
		props.design.event_container_border_radius ?
		`${props.design.event_container_border_radius}px` :
		`.5rem`
	};
    border-width: ${(props: any) => 
		props.design.event_container_border_width ?
		`${props.design.event_container_border_width}px` :
		`1px`
	};
    border-style: solid;
    border-color: ${(props: any) =>
        props.design.event_container_border_color &&
        isValidHexColor(props.design.event_container_border_color) ?
        props.design.event_container_border_color :
        '#D5D8DF'
    };
    background-color: ${(props: any) => 
        props.design.event_container_background_color &&
        isValidHexColor(props.design.event_container_background_color) ?
        props.design.event_container_background_color :
        '#FFFFFF'
    };
    box-shadow: ${(props: any) => 
        props.design.event_container_shadow_color &&
        isValidHexColor(props.design.event_container_shadow_color) ?
        props.design.event_container_shadow_position === ShadowPosition.Even ?
        `0px 0px 8px rgba(${miscUtils.hexToRgb(props.design.event_container_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.event_container_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.event_container_shadow_color)!.b}, ${props.design.event_container_shadow_opacity ? props.design.event_container_shadow_opacity : 0.0})` :
        props.design.event_container_shadow_position === ShadowPosition.Bottom ?
        `0px 4px 8px rgba(${miscUtils.hexToRgb(props.design.event_container_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.event_container_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.event_container_shadow_color)!.b}, ${props.design.event_container_shadow_opacity ? props.design.event_container_shadow_opacity : 0.0})` :
        props.design.event_container_shadow_position === ShadowPosition.Top ?
        `0px -4px 8px rgba(${miscUtils.hexToRgb(props.design.event_container_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.event_container_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.event_container_shadow_color)!.b}, ${props.design.event_container_shadow_opacity ? props.design.event_container_shadow_opacity : 0.0})` :
        props.design.event_container_shadow_position === ShadowPosition.BottomRight ?
        `2px 4px 8px rgba(${miscUtils.hexToRgb(props.design.event_container_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.event_container_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.event_container_shadow_color)!.b}, ${props.design.event_container_shadow_opacity ? props.design.event_container_shadow_opacity : 0.0})` :
        props.design.event_container_shadow_position === ShadowPosition.BottomLeft ?
        `-2px 4px 8px rgba(${miscUtils.hexToRgb(props.design.event_container_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.event_container_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.event_container_shadow_color)!.b}, ${props.design.event_container_shadow_opacity ? props.design.event_container_shadow_opacity : 0.0})` :
        props.design.event_container_shadow_position === ShadowPosition.TopRight ?
        `2px -4px 8px rgba(${miscUtils.hexToRgb(props.design.event_container_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.event_container_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.event_container_shadow_color)!.b}, ${props.design.event_container_shadow_opacity ? props.design.event_container_shadow_opacity : 0.0})` :
        props.design.event_container_shadow_position === ShadowPosition.TopLeft ?
        `-2px -4px 8px rgba(${miscUtils.hexToRgb(props.design.event_container_shadow_color)!.r}, ${miscUtils.hexToRgb(props.design.event_container_shadow_color)!.g}, ${miscUtils.hexToRgb(props.design.event_container_shadow_color)!.b}, ${props.design.event_container_shadow_opacity ? props.design.event_container_shadow_opacity : 0.0})` :
        'none'
        :
        'none'
    };
    cursor: pointer;
    overflow: hidden;
    padding: 10px;

    &.mobile {
		flex: 0 0 100%;
	}

	@media(max-width: 768px) {
		flex: 0 0 100%;
	}
`;

const EventImageContainer: any = styled.div`
	width: 100%;
	height: auto;
    aspect-ratio: 293 / 93;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #D5D8DF;
    border-radius: .5rem;
    overflow: hidden;

	transition: .5s;
	
	&:hover {
		opacity: .8;
	}
`;

const EventImage: any = styled.img`
	width: 100%;
	height: 100%;
	object-fit: cover;
`;

const EventContainer: any = styled.div`
    width: 100%;
    padding-top: 10px;
    cursor: pointer;
`;

// const EventHeaderContainer: any = styled.div`
//     // display: flex;
//     // justify-content: space-between;
// `;

// const EventHeaderDayContainer: any = styled.div`
//     display: flex;
//     flex-direction: column;
// `;

// const EventHeaderDayNumber: any = styled.span`
//     display: block;              
//     font-style: normal;
//     font-weight: 700;
//     font-size: 36px;
//     line-height: 41px;
//     text-transform: capitalize;
//     color: #191b1f ;
// `;

// const EventHeaderDayMonth: any = styled.span`
//     display: block;         
//     font-style: normal;
//     font-weight: 400;
//     font-size: 14px;
//     line-height: 20px;
//     text-transform: capitalize;
//     color: #666666;
// `;

// const EventHeaderRelativeContainer: any = styled.div<{design: any}>`
//     background-color: ${(props) => 
//         props.design.event_countdown_background_color &&
//         isValidHexColor(props.design.event_countdown_background_color) ?
//         `${props.design.event_countdown_background_color}` :
//         '#365DE626'
//     };
//     border-radius: 4px;
//     width: fit-content;
//     height: 23px;
//     padding: 0 10px;
//     display: flex;
//     align-items: center;
//     justify-content: center;
// `;

// const EventHeaderRelativeText: any = styled.span`
//     display: block;              
//     font-style: normal;
//     font-weight: 400;
//     font-size: 13px;
//     line-height: 15px;
//     color: #365DE6;
//     text-transform: capitalize;
//     font-size: ${(props: any) =>
// 		props.design.event_countdown_font_size &&
// 		props.design.event_countdown_font_size <= 50 ?
// 		`${props.design.event_countdown_font_size}px` :
// 		`18px`
// 	};
// 	line-height: ${(props: any) =>
// 		props.design.event_countdown_line_height &&
// 		props.design.event_countdown_line_height <= 50 ?
// 		`${props.design.event_countdown_line_height}px` :
// 		`22px`
// 	};
// 	font-family: ${(props: any) =>
// 		props.design.event_countdown_font_family ?
// 		`${props.design.event_countdown_font_family} !important` :
// 		`-apple-system, Arial !important`
// 	};
// 	color: ${(props: any) => 
// 		props.design.event_countdown_color &&
// 		isValidHexColor(props.design.event_countdown_color) ?
// 		props.design.event_countdown_color :
// 		'#000000'
// 	};
// 	transition: .5s;

// 	&:hover {
// 		color: ${(props: any) => 
// 			props.design.event_countdown_color_hover &&
// 			isValidHexColor(props.design.event_countdown_color_hover) ?
// 			props.design.event_countdown_color_hover  :
// 			'#365DE6'
// 		};
// 	}
// `;

const EventTitle: any = styled.p<{design: any}>`
    margin: 0;
    padding: 0;
    margin-top: 0;
    font-style: normal;
    font-weight: 700;
    text-transform: capitalize;
    color: #191b1f;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    font-size: ${(props: any) =>
		props.design.event_name_font_size &&
		props.design.event_name_font_size <= 50 ?
		`${props.design.event_name_font_size}px` :
		`18px`
	};
	line-height: ${(props: any) =>
		props.design.event_name_line_height &&
		props.design.event_name_line_height <= 50 ?
		`${props.design.event_name_line_height}px` :
		`22px`
	};
	font-family: ${(props: any) =>
		props.design.event_name_font_family ?
		`${props.design.event_name_font_family} !important` :
		`-apple-system, Arial !important`
	};
	color: ${(props: any) => 
		props.design.event_name_color &&
		isValidHexColor(props.design.event_name_color) ?
		props.design.event_name_color :
		'#000000'
	};
	transition: .5s;

	&:hover {
		color: ${(props: any) => 
			props.design.event_name_color_hover &&
			isValidHexColor(props.design.event_name_color_hover) ?
			props.design.event_name_color_hover  :
			'#365DE6'
		};
	}
`;

const EventTime: any = styled.span`
    display: block;
    margin-top: 10px; 
    font-style: normal;
    font-weight: 400;
    font-size: ${(props: any) =>
		props.design.event_time_font_size &&
		props.design.event_time_font_size <= 50 ?
		`${props.design.event_time_font_size}px` :
		`18px`
	};
	line-height: ${(props: any) =>
		props.design.event_time_line_height &&
		props.design.event_time_line_height <= 50 ?
		`${props.design.event_time_line_height}px` :
		`22px`
	};
	font-family: ${(props: any) =>
		props.design.event_time_font_family ?
		`${props.design.event_time_font_family} !important` :
		`-apple-system, Arial !important`
	};
	color: ${(props: any) => 
		props.design.event_time_color &&
		isValidHexColor(props.design.event_time_color) ?
		props.design.event_time_color :
		'#000000'
	};
	transition: .5s;

	&:hover {
		color: ${(props: any) => 
			props.design.event_time_color_hover &&
			isValidHexColor(props.design.event_time_color_hover) ?
			props.design.event_time_color_hover  :
			'#365DE6'
		};
	}
`;

// const EventAttendeesCount: any = styled.p`
//     margin: 0;
//     padding: 0;
//     margin-top: 10px; 
//     font-style: normal;
//     font-weight: 400;
//     white-space: nowrap;
//     text-overflow: ellipsis;
//     overflow: hidden;
//     max-width: 100%;
//     font-size: ${(props: any) =>
// 		props.design.event_attendees_font_size &&
// 		props.design.event_attendees_font_size <= 50 ?
// 		`${props.design.event_attendees_font_size}px` :
// 		`18px`
// 	};
// 	line-height: ${(props: any) =>
// 		props.design.event_attendees_line_height &&
// 		props.design.event_attendees_line_height <= 50 ?
// 		`${props.design.event_attendees_line_height}px` :
// 		`22px`
// 	};
// 	font-family: ${(props: any) =>
// 		props.design.event_attendees_font_family ?
// 		`${props.design.event_attendees_font_family} !important` :
// 		`-apple-system, Arial !important`
// 	};
// 	color: ${(props: any) => 
// 		props.design.event_attendees_color &&
// 		isValidHexColor(props.design.event_attendees_color) ?
// 		props.design.event_attendees_color :
// 		'#000000'
// 	};
// 	transition: .5s;

// 	&:hover {
// 		color: ${(props: any) => 
// 			props.design.event_attendees_color_hover &&
// 			isValidHexColor(props.design.event_attendees_color_hover) ?
// 			props.design.event_attendees_color_hover  :
// 			'#365DE6'
// 		};
// 	}
// `;

const EventsBlockEventPreview: React.FC<IEventsBlockEventPreviewProps> = (props) => {

    // const isInProgress = () => {
    //     const now = moment.utc();
    //     const startDate = moment.utc(props.event.start_time);
    //     const endDate = moment.utc(props.event.end_time);

    //     return startDate.isBefore(now) && endDate.isAfter(now);
    // }

    // const showRelativeTime = () => {
    //     const now = moment.utc();
    //     const startDate = moment.utc(props.event.start_time);
    //     const isStartingSoon = startDate.isAfter(now) && startDate.diff(now, 'days') <= 7;

    //     return isInProgress() || isStartingSoon;
    // }

    const ctaOnClick = () => {
        if(props.buildingPreview) {
            return;
        }

        window.open(
        `${miscUtils.getRedirectBaseUrl(props.group)}/events/${props.event.slug}`, 
        '_self'
        );
    }

  return (
    <EventWrapper
    className={`${props.index === 0 ? 'first' : ''} ${props.view ? props.view : ''}`}
    design={props.design}
    onClick={ctaOnClick}
    >
        <EventImageContainer
        >
        {props.event.cover_image ? (
            <EventImage
            src={props.event.cover_image}
            />
        ) : (
            <ImageIcon
            />
        )}
        </EventImageContainer>
        <EventContainer
        >
            {/* {showRelativeTime() ? (
                <EventHeaderRelativeContainer
                design={props.design}
                >
                    <EventHeaderRelativeText
                    design={props.design}
                    >
                        {isInProgress() ? (
                            <span>In progress</span>
                        ) : (
                            <Moment 
                            utc 
                            fromNow
                            tz={miscUtils.getUserTimezone()}
                            >
                                {props.event.start_time}
                            </Moment>
                        )}
                    </EventHeaderRelativeText>
                </EventHeaderRelativeContainer>
            ) : <></>} */}

            <EventTitle
            design={props.design}
            // showingRelativeTime={showRelativeTime()}
            >
                {props.event.title}
            </EventTitle>
            <EventTime 
            design={props.design}
            >
                {/* <Moment utc={true} format="dddd, hh:mm A" tz={miscUtils.getUserTimezone()}>{props.event.start_time}</Moment> - {" "}
                <Moment utc={true} format="dddd, hh:mm A" tz={miscUtils.getUserTimezone()}>{props.event.end_time}</Moment>
                {miscUtils.getReadableTimezoneOffset(miscUtils.getUserTimezone()) && ` (${miscUtils.getUserTimezoneAbbreviation()} ${miscUtils.getReadableTimezoneOffset(miscUtils.getUserTimezone())})`} */}

                <Moment utc format="ddd" tz={miscUtils.getUserTimezone()}>{props.event.start_time}</Moment>{", "}
                <Moment utc format="MMM" tz={miscUtils.getUserTimezone()}>{props.event.start_time}</Moment>{" "}
                <Moment utc format="DD" tz={miscUtils.getUserTimezone()}>{props.event.start_time}</Moment>
                {
                    eventsUtils.showStartDateYear(props.event.start_time, props.event.end_time) ? (
                        <>
                        {", "}
                        <Moment utc format="YYYY" tz={miscUtils.getUserTimezone()}>{props.event.start_time}</Moment>
                        </>
                    ) : <></>
                }
                {
                    eventsUtils.eventIsInSameDay(props.event) ?
                    <>,{" "}</> :
                    <>
                    {" "}-{" "}
                    <Moment utc format="ddd" tz={miscUtils.getUserTimezone()}>{props.event.end_time && props.event.end_time}</Moment>{", "}
                    <Moment utc format="MMM" tz={miscUtils.getUserTimezone()}>{props.event.end_time && props.event.end_time}</Moment>{" "}
                    <Moment utc format="DD" tz={miscUtils.getUserTimezone()}>{props.event.end_time && props.event.end_time}</Moment>{", "}
                    {
                        eventsUtils.showEndDateYear(props.event.end_time) ?
                        <>
                        <Moment utc format="YYYY" tz={miscUtils.getUserTimezone()}>{props.event.end_time && props.event.end_time}</Moment>{", "}
                        </> :
                        <></>
                    }
                    </>
                }
                <Moment utc format="h:mm A" tz={miscUtils.getUserTimezone()}>{props.event.start_time}</Moment> - {" "}
                <Moment utc format="h:mm A" tz={miscUtils.getUserTimezone()}>{props.event.end_time}</Moment>
                {/* {miscUtils.getReadableTimezoneOffset(miscUtils.getUserTimezone()) ? ` (${miscUtils.getUserTimezoneAbbreviation()} ${miscUtils.getReadableTimezoneOffset(miscUtils.getUserTimezone())})` : ''} */}
            </EventTime>
            {/* {!props.event.hide_rsvp_count ? (
                <EventAttendeesCount
                design={props.design}
                >
                    {props.event.rsvps_count} attending
                </EventAttendeesCount>
            ) : (<></>)} */}
        </EventContainer>
    </EventWrapper>
  )
}

export default EventsBlockEventPreview;